import LinearProgress from '@mui/material/LinearProgress';

export default LinearProgress;
